export const QUESTION_TYPE = {
    TextQuestion: "escrita",
    SingleQuestion: "unica",
    MultiQuestion: "multiple",
    Info: "information"
}

export const SERVICES = {
    YOUTUBE: "YouTube",
    VIMEO: "Vimeo",
    TWITCH: "Twitch",
    ONLINE: "Online",
}

export const GAMEMODE = {
    SEQUENTIAL: "sequential",
    FREEDOM: "freedom",
}

export const VIEW_COUNT_DURATION = 800;

export const SERVICES_FILTER = {
    [SERVICES.YOUTUBE]: /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    [SERVICES.VIMEO]: /(?:https?:\/\/)?(?:www\.)?vimeo\.com(?:\/video)?\/(\d+)/,
    [SERVICES.TWITCH]: /(?:https?:\/\/)?(?:www\.)?twitch\.tv\/([^/\s]+)/,
    [SERVICES.ONLINE]: /(?:https?:\/\/)?(?:www\.)?.*\.(mp4|webm|ogv|mpd|m3u8)$/
}

export const VIDEOQUIZ_SOUNDS = {
    WRITE: "write",
    DELETE: "delete",
    SUBMIT: "submit",
    CHARGE: "charge",   
    MOVE: "move",
}

export const NAME_INPUT = "options";